<template>
  <nav id="sidebarMenu" :class="displayStyle + ' bg-light sidebar collapse'">
    <div v-if="visibleManagerH" class="position-sticky pt-3">
      <ul class="nav flex-column">
        <li class="nav-item">
          <router-link to="/" class="nav-link" aria-current="page" href="#">
            <vue-feather type="home" />
            HOME
          </router-link>
        </li>
      </ul>
      <h6
        class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted"
        v-if="
          chk_relation_prefix_target('/application/') ||
          chk_relation_prefix_target('/club_application/')
        "
      >
        <span>申請データ</span>
        <i class="bi bi-person-circle"></i>
      </h6>
      <ul
        class="nav flex-column"
        v-if="
          chk_relation_prefix_target('/application/') ||
          chk_relation_prefix_target('/club_application/')
        "
      >
        <li class="nav-item" v-if="chk_relation_target('/application/list')">
          <router-link
            to="/application/list"
            class="nav-link"
            aria-current="page"
            href="#"
          >
            <i class="bi bi-window-plus"></i>
            会員の申請
          </router-link>
        </li>
        <li
          class="nav-item"
          v-if="chk_relation_target('/club_application/list')"
        >
          <router-link
            to="/club_application/list"
            class="nav-link"
            aria-current="page"
            href="#"
          >
            <i class="bi bi-window-plus"></i>
            公認クラブの申請
          </router-link>
        </li>
        <li
          class="nav-item"
          v-if="chk_relation_target('/owner_application/list')"
        >
          <router-link
            to="/owner_application/list"
            class="nav-link"
            aria-current="page"
            href="#"
          >
            <i class="bi bi-window-plus"></i>
            主催者の申請
          </router-link>
        </li>
      </ul>
      <h6
        class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted d-none"
      >
        <span>レースイベント</span>
        <i class="bi bi-person-circle"></i>
      </h6>
      <ul class="nav flex-column d-none">
        <li class="nav-item">
          <router-link
            to="/event/list"
            class="nav-link"
            aria-current="page"
            href="#"
          >
            <i class="bi bi-search"></i>
            一覧
          </router-link>
        </li>
      </ul>
      <h6
        class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted d-none"
      >
        <span>昇降格/ランキング</span>
        <i class="bi bi-person-circle"></i>
      </h6>
      <ul class="nav flex-column d-none">
        <li class="nav-item">
          <router-link
            to="/promotion_cond/list"
            class="nav-link"
            aria-current="page"
            href="#"
          >
            <i class="bi bi-search"></i>
            昇降格条件
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            to="/promotion/ranking"
            class="nav-link"
            aria-current="page"
            href="#"
          >
            <i class="bi bi-search"></i>
            昇格者決定
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            to="/promotion/list"
            class="nav-link"
            aria-current="page"
            href="#"
          >
            <i class="bi bi-search"></i>
            昇降格者一覧・実行
          </router-link>
        </li>
      </ul>
      <h6
        class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted"
        v-if="chk_relation_prefix_target('/member/')"
      >
        <span>会員データ</span>
        <i class="bi bi-person-circle"></i>
      </h6>
      <ul class="nav flex-column" v-if="chk_relation_prefix_target('/member/')">
        <li class="nav-item" v-if="chk_relation_target('/member/list')">
          <router-link
            to="/member/list"
            class="nav-link"
            aria-current="page"
            href="#"
          >
            <i class="bi bi-search"></i>
            会員検索
          </router-link>
        </li>
        <li class="nav-item" v-if="chk_relation_target('/member/add')">
          <router-link
            to="/member/add"
            class="nav-link"
            aria-current="page"
            href="#"
          >
            <i class="bi bi-plus"></i>
            会員登録
          </router-link>
        </li>
      </ul>
      <h6
        class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted"
        v-if="chk_relation_prefix_target('/club/')"
      >
        <span>公認クラブデータ</span>
        <i class="bi bi-people"></i>
      </h6>
      <ul class="nav flex-column" v-if="chk_relation_prefix_target('/club/')">
        <li class="nav-item" v-if="chk_relation_target('/club/list')">
          <router-link
            to="/club/list"
            class="nav-link"
            aria-current="page"
            href="#"
          >
            <i class="bi bi-search"></i>
            クラブ検索
          </router-link>
        </li>
        <li class="nav-item" v-if="chk_relation_target('/club/add')">
          <router-link
            to="/club/add"
            class="nav-link"
            aria-current="page"
            href="#"
          >
            <i class="bi bi-plus"></i>
            クラブ登録
          </router-link>
        </li>
      </ul>
      <h6
        class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted"
        v-if="chk_relation_prefix_target('/information/')"
      >
        <span>マイページ管理</span>
        <i class="bi bi-building"></i>
      </h6>
      <ul
        class="nav flex-column"
        v-if="chk_relation_prefix_target('/information/')"
      >
        <li class="nav-item" v-if="chk_relation_target('/information/list')">
          <router-link
            to="/information/list"
            class="nav-link"
            aria-current="page"
            href="#"
          >
            <i class="bi bi-search"></i>
            お知らせ一覧
          </router-link>
        </li>
      </ul>
      <h6
        class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted"
        v-if="chk_relation_prefix_target('/owner/')"
      >
        <span>主催者データ</span>
        <i class="bi bi-building"></i>
      </h6>
      <ul class="nav flex-column" v-if="chk_relation_prefix_target('/owner/')">
        <li class="nav-item" v-if="chk_relation_target('/owner/list')">
          <router-link
            to="/owner/list"
            class="nav-link"
            aria-current="page"
            href="#"
          >
            <i class="bi bi-search"></i>
            主催者検索
          </router-link>
        </li>
        <li class="nav-item" v-if="chk_relation_target('/owner/add')">
          <router-link
            to="/owner/add"
            class="nav-link"
            aria-current="page"
            href="#"
          >
            <i class="bi bi-plus"></i>
            主催者登録
          </router-link>
        </li>
      </ul>
      <h6
        v-if="
          manage_account_level_disp &&
          chk_relation_prefix_target('/system_entry/')
        "
        class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted"
      >
        <span>エントリーシステム</span>
        <i class="bi bi-building"></i>
      </h6>
      <ul
        class="nav flex-column"
        v-if="chk_relation_prefix_target('/system_entry/')"
      >
        <li class="nav-item">
          <router-link
            to="/system_entry/list"
            class="nav-link"
            aria-current="page"
            href="#"
          >
            <i class="bi bi-search"></i>
            申請一覧
          </router-link>
        </li>
      </ul>
      <h6
        class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted"
      >
        <span>外部リンク</span>
        <i class="bi bi-box-arrow-up-right"></i>
      </h6>
      <ul class="nav flex-column">
        <li class="nav-item">
          <a
            class="nav-link"
            target="_blank"
            href="https://www3.ms-event.net/mfj_renewal/event/"
          >
            <i class="bi bi-login"></i>
            競技会管理
          </a>
        </li>
      </ul>
      <h6
        class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted"
        v-if="chk_relation_prefix_target('/sales/')"
      >
        <span>販売管理</span>
        <i class="bi bi-gear-fill"></i>
      </h6>
      <ul class="nav flex-column" v-if="chk_relation_prefix_target('/sales/')">
        <li class="nav-item" v-if="chk_relation_target('/sales/list')">
          <router-link
            to="/sales/data_list"
            class="nav-link"
            aria-current="page"
            href="#"
          >
            <i class="bi bi-credit-card"></i>
            販売データ一覧
          </router-link>
        </li>
        <li
          class="nav-item"
          v-if="chk_relation_target('/payment_setting/list')"
        >
          <router-link
            to="/payment_setting/list"
            class="nav-link"
            aria-current="page"
            href="#"
          >
            <i class="bi bi-cart"></i>
            決済設定
          </router-link>
        </li>
        <li class="nav-item" v-if="chk_relation_target('/sales/csv_export')">
          <router-link
            to="/sales/csv_export"
            class="nav-link"
            aria-current="page"
            href="#"
          >
            <i class="bi bi-database"></i>
            販売データCSV出力
          </router-link>
        </li>
        <li class="nav-item" v-if="chk_relation_target('/insurance/list')">
          <router-link to="/insurance/list" class="nav-link">
            <i class="bi bi-database"></i>
            保険出力
          </router-link>
        </li>
        <li
          class="nav-item d-none"
          v-if="chk_relation_target('/sales/journal')"
        >
          <router-link to="/sales/journal" class="nav-link">
            <i class="bi bi-database"></i>
            日次売上処理
          </router-link>
        </li>
        <li
          class="nav-item d-none"
          v-if="chk_relation_target('/sales/error_check')"
        >
          <router-link
            to="/sales/error_check"
            class="nav-link"
            aria-current="page"
            href="#"
          >
            <i class="bi bi-database"></i>
            売上確認(ERRORチェック)
          </router-link>
        </li>
        <li class="nav-item" v-if="manage_account_level_disp">
          <router-link to="/sales/get_payment_log" class="nav-link">
            <i class="bi bi-database"></i>
            ログ
          </router-link>
        </li>
      </ul>
      <h6
        class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted"
        v-if="chk_relation_prefix_target('/article')"
      >
        <span>商品マスタ管理</span>
        <i class="bi bi-gear-fill"></i>
      </h6>
      <ul class="nav flex-column">
        <li
          class="nav-item"
          v-if="chk_relation_target('/article_category/list')"
        >
          <router-link
            to="/article_category/list"
            class="nav-link"
            aria-current="page"
            href="#"
          >
            <i class="bi bi-database"></i>
            商品カテゴリマスタ
          </router-link>
        </li>
        <li class="nav-item" v-if="chk_relation_target('/article/list')">
          <router-link
            to="/article/list"
            class="nav-link"
            aria-current="page"
            href="#"
          >
            <i class="bi bi-database"></i>
            商品マスタ
          </router-link>
        </li>
      </ul>

      <h6
        class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted"
        v-if="
          chk_relation_prefix_target_some([
            '/master',
            '/license_event_cd',
            '/license_cd',
            '/license_promotion',
            '/event_cd',
            '/area_region',
            '/race_type',
            '/area_pref',
            '/circuit',
            '/migration',
            '/enquate',
            '/race_owner_type_cd'
          ])
        "
      >
        <span>マスタ管理</span>
        <i class="bi bi-gear-fill"></i>
      </h6>
      <ul class="nav flex-column">
        <li class="nav-item" v-if="chk_relation_target('/master/list')">
          <router-link
            to="/master/list"
            class="nav-link"
            aria-current="page"
            href="#"
          >
            <i class="bi bi-database"></i>
            マスタ管理
          </router-link>
        </li>
        <li class="nav-item" v-if="chk_relation_target('/master/list')">
          <router-link
            to="/license_cd/list"
            class="nav-link"
            aria-current="page"
            href="#"
          >
            <i class="bi bi-database"></i>
            ライセンスマスタ
          </router-link>
        </li>
        <li class="nav-item" v-if="chk_relation_target('/master/list')">
          <router-link
            to="/license_promotion/1"
            class="nav-link"
            aria-current="page"
            href="#"
          >
            <i class="bi bi-search"></i>
            役員昇格条件マスタ
          </router-link>
        </li>
        <li class="nav-item" v-if="chk_relation_target('/master/list')">
          <router-link
            to="/license_event_cd/list"
            class="nav-link"
            aria-current="page"
            href="#"
          >
            <i class="bi bi-database"></i>
            競技種目マスタ
          </router-link>
        </li>
        <li class="nav-item" v-if="chk_relation_target('/master/list')">
          <router-link
            to="/event_cd/list"
            class="nav-link"
            aria-current="page"
            href="#"
          >
            <i class="bi bi-database"></i>
            競技会用種目マスタ
          </router-link>
        </li>
        <li class="nav-item d-none">
          <router-link
            to="/race_class/list"
            class="nav-link"
            aria-current="page"
            href="#"
          >
            <i class="bi bi-database"></i>
            クラスマスタ
          </router-link>
        </li>
        <li class="nav-item d-none">
          <router-link
            to="/race_type/list"
            class="nav-link"
            aria-current="page"
            href="#"
          >
            <i class="bi bi-database"></i>
            格式マスタ
          </router-link>
        </li>
        <li class="nav-item d-none">
          <router-link
            to="/race_series/list"
            class="nav-link"
            aria-current="page"
            href="#"
          >
            <i class="bi bi-database"></i>
            シリーズマスタ
          </router-link>
        </li>
        <li class="nav-item d-none">
          <router-link
            to="/point_block/list"
            class="nav-link"
            aria-current="page"
            href="#"
          >
            <i class="bi bi-gear"></i>
            ポイントブロックマスタ
          </router-link>
        </li>
        <li class="nav-item" v-if="chk_relation_target('/master/list')">
          <router-link
            to="/area_region/list"
            class="nav-link"
            aria-current="page"
            href="#"
          >
            <i class="bi bi-gear"></i>
            地域マスタ
          </router-link>
        </li>
        <li class="nav-item" v-if="chk_relation_target('/master/list')">
          <router-link
            to="/area_pref/list"
            class="nav-link"
            aria-current="page"
            href="#"
          >
            <i class="bi bi-gear"></i>
            都道府県マスタ
          </router-link>
        </li>
        <li class="nav-item d-none">
          <router-link
            to="/area_district/list"
            class="nav-link"
            aria-current="page"
            href="#"
          >
            <i class="bi bi-gear"></i>
            地区マスタ
          </router-link>
        </li>
        <li class="nav-item" v-if="chk_relation_target('/master/list')">
          <router-link
            to="/circuit/list"
            class="nav-link"
            aria-current="page"
            href="#"
          >
            <i class="bi bi-gear"></i>
            サーキットマスタ
          </router-link>
        </li>
        <li class="nav-item" v-if="chk_relation_target('/master/list')">
          <router-link
            to="/race_owner_type_cd/list"
            class="nav-link"
            aria-current="page"
            href="#"
          >
            <i class="bi bi-gear"></i>
            主催者種別マスタ
          </router-link>
        </li>
        <li class="nav-item" v-if="chk_relation_target('/master/list')">
          <router-link
            to="/migration/list"
            class="nav-link"
            aria-current="page"
            href="#"
          >
            <i class="bi bi-gear"></i>
            移行データ
          </router-link>
        </li>
        <li class="nav-item" v-if="chk_relation_target('/master/list')">
          <router-link
            to="/enquate/list"
            class="nav-link"
            aria-current="page"
            href="#"
          >
            <i class="bi bi-gear"></i>
            アンケート
          </router-link>
        </li>
      </ul>
      <h6
        class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted"
        v-if="chk_relation_prefix_target_some(['manage', 'manage_role'])"
      >
        <span>基本設定</span>
        <i class="bi bi-house-fill"></i>
      </h6>
      <ul
        class="nav flex-column"
        v-if="chk_relation_prefix_target_some(['/manage/', '/manage_role/'])"
      >
        <li class="nav-item" v-if="chk_relation_target('/manage/list')">
          <router-link
            to="/manage/list"
            class="nav-link"
            aria-current="page"
            href="#"
          >
            <i class="bi bi-gear"></i>
            管理者設定
          </router-link>
        </li>
        <li class="nav-item" v-if="chk_relation_target('/manage/list')">
          <router-link
            to="/manage_role/list"
            class="nav-link"
            aria-current="page"
            href="#"
          >
            <i class="bi bi-gear"></i>
            管理権限設定
          </router-link>
        </li>
      </ul>
      <ul class="nav flex-column mb-5">
        <li class="nav-item">
          <router-link
            to="/logout"
            class="nav-link"
            aria-current="page"
            href="#"
          >
            <i class="fa bi-box-arrow-right"></i>
            ログアウト
          </router-link>
        </li>
      </ul>
    </div>
    <div v-else class="position-sticky pt-3">
      <ul class="nav flex-column">
        <li class="nav-item">
          <router-link to="/" class="nav-link" aria-current="page" href="#">
            <vue-feather type="home" />
            HOME
          </router-link>
        </li>
      </ul>
      <ul class="nav flex-column">
        <li class="nav-item">
          <router-link
            to="/ticket/add"
            class="nav-link"
            aria-current="page"
            href="#"
          >
            <i class="fa bi-pencil"></i>
            予診票記入
          </router-link>
        </li>
      </ul>
      <ul class="nav flex-column">
        <li class="nav-item">
          <router-link
            to="/logout"
            class="nav-link"
            aria-current="page"
            href="#"
          >
            <i class="bi bi-box-arrow-right"></i>
            ログアウト
          </router-link>
        </li>
      </ul>
    </div>
  </nav>
</template>
<style>
#sidebarMenu {
  position: fixed !important;
  top: 56px !important;
  bottom: 0 !important;
  left: 0 !important;
  width: 16.666667% !important;
  z-index: 100 !important;
  padding-top: 0 !important;
  overflow-x: hidden !important;
  overflow-y: hidden !important;
  background-color: #f8f9fa !important;
}

.position-sticky {
  position: relative !important;
  height: 100% !important;
  max-height: 100vh !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  padding-bottom: 20px !important;
}

@media (max-width: 767.98px) {
  #sidebarMenu {
    width: 100% !important;
  }
}
</style>
<script>
import { mapState } from 'vuex'
import 'feather'
import 'vue-feather'
import VueFeather from 'vue-feather'
// import { ActivityIcon } from "vue-feather-icons";
export default {
  name: 'BsSideMenuView',
  components: {
    VueFeather
  },
  data: function () {
    return {
      auth: this.$store.state.auth
      // displaySw: false
    }
  },
  props: {
    displaySw: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState({
      // co_data: state => state.apidata.co_data,
    }),
    // chk_relation_target: function () {
    //   const roles = this.$store?.state?.auth?.relations
    //   const level = this.$store?.state?.auth?.level
    //   return function (target) {
    //     if (parseInt(level) <= 0) {
    //       if (
    //         Array.isArray(roles) &&
    //         roles.find(role => {
    //           console.log('role.page_path', role.page_path)
    //           const regex = this.page_path_reg_exp(role.page_path)
    //           return regex.test(target)
    //         })
    //       ) {
    //         return true
    //       }
    //       return false
    //     }
    //     return true
    //   }
    // },
    visibleManagerH() {
      if (this.$store.state.auth.level < 1000) {
        return true
      }
      return false
    },
    displayStyle() {
      // validを使ってログイン処理の可否、progressは後述

      if (this.displaySw) {
        return 'col-md-3 col-lg-2 d-block d-md-block'
      } else {
        return 'd-none'
      }
    }
  },
  methods: {
    // toggleMenu(){
    //     this.$refs.navButton.classList.toggle('navButton--open');
    //     this.$refs.navBody.classList.toggle('nav--open');
    // },
    routerLinkAction(to_path) {
      this.$router.push({ path: to_path })
    },
    // `click`イベントを発行
    handleClearData(ev) {
      if (this.$refs.navBody.classList.contains('nav--open')) {
        this.toggleMenu()
      }
      this.$emit('to_clear_event', ev)
    }
  }
}
</script>
